module.exports = __webpack_public_path__ + "img/238.d3ae5999.png";